import { useQuery } from '@tanstack/react-query';
import { GET_USER_STATS } from '../queries/stats';
import { graphqlFetch } from '@/utils/graphqlFetch';
import { UserStatsOutput, UserStatsQuery } from '../gql/graphql';

export const useUserStats = (input: UserStatsQuery) => {
  return useQuery<UserStatsOutput, Error>({
    queryKey: ['userStats', input],
    queryFn: async () => {
      const data = await graphqlFetch<
        { getStats: UserStatsOutput },
        { input: UserStatsQuery }
      >(GET_USER_STATS, {
        input,
      });
      return data.getStats;
    },
  });
};
